export type MainMenuKey = 'commercial' | 'resident' | 'baseinfo';

export const MAIN_MENU_STORAGE_KEY = 'UMI_MAIN_MENU_KEY';

export const MAIN_MENU_OPTIONS: Array<{ name: string; key: MainMenuKey,code:string }> = [
  { name: '非居民清运', key: 'commercial',code:"no_residential_clear"},
  { name: '居民清运', key: 'resident',code:"residential_clear" },
  { name: '基础信息', key: 'baseinfo',code:"basic_info" },
];

const MAIN_MENU_PATH_PREFIX_MAP: Record<MainMenuKey, string[]> = {
  commercial: [
    '/base-info',
    '/weight-record',
    '/garbage-record',
    '/vehicle-operation',
    "/expiration-reminder",
    '/reconciliation',
    '/invoice',
    '/payment-collection',
    '/immediate-payment',
    '/charge',
    '/balance-reminder',
    '/absorption',
    '/wasteOrder',
    '/statistical',
    '/rule-config',
    '/smart-assistant',
    
  ],
  resident: ["/rbase-info","/rgarbage-record","/rabsorption","/rsmart-assistant","/data-reporting","/data-acquisition",],
  baseinfo: [ '/system-config',"/bvehicle-operation","/bperson-operation","/boperating-entity","/babsorption","/business-classification","/bsmart-assistant",  ],
};

export const normalizeMainMenuKey = (value?: string): MainMenuKey => {
  if (value === 'resident' || value === 'baseinfo' || value === 'commercial') {
    return value;
  }
  return 'commercial';
};

export const getMainMenuByPath = (pathname: string): MainMenuKey => {
  const matched = (Object.keys(MAIN_MENU_PATH_PREFIX_MAP) as MainMenuKey[]).find(
    (mainMenuKey) =>
      MAIN_MENU_PATH_PREFIX_MAP[mainMenuKey].some((prefix) =>
        pathname.startsWith(prefix),
      ),
  );
  return matched || 'commercial';
};

export const filterMenusByMainMenu = (
  menus: any[],
  activeMainMenu: MainMenuKey,
): any[] => {
  const prefixes = MAIN_MENU_PATH_PREFIX_MAP[activeMainMenu] || [];
  const pathVisible = (path?: string) => !path || prefixes.some((prefix) => path.startsWith(prefix));

  const loop = (items: any[]): any[] =>
    items
      .map((item) => {
        const children = Array.isArray(item.routes) ? loop(item.routes) : [];
        if (!pathVisible(item.path) && children.length === 0) {
          return null;
        }
        if (children.length > 0) {
          return { ...item, children };
        }
        return { ...item };
      })
      .filter(Boolean) as any[];

  return loop(menus);
};

export const findFirstVisibleMenuPath = (menus: any[]): string | undefined => {
  for (const item of menus) {
    if (Array.isArray(item.children) && item.children.length > 0) {
      const childPath = findFirstVisibleMenuPath(item.children);
      if (childPath) {
        return childPath;
      }
    }

    if (item.path && !item.hideInMenu) {
      return item.path;
    }
  }

  return undefined;
};
